{
  "fr": {
    "milestone": {
      "actions": {
        "activate": "Activer",
        "active": "Actif !",
        "create": "Créer un jalon",
        "deactivate": "Désactiver",
        "delete": "Supprimer",
        "delete_milestones": "Supprimer le jalon | Supprimer {count} jalons",
        "new": "Jalon"
      },
      "labels": {
        "bulk_assign_title": "Sélectionnez les unités auxquelles vous souhaitez attribuer le jalon '{milestone_name}'",
        "edit_milestone": "Editer le jalon",
        "edit_units": "Modifier les unités",
        "empty_state_subtitle": "Les jalons rendent le processus de construction plus transparent pour les acheteurs de maison",
        "empty_state_title": "Créer un nouveau jalon",
        "future_milestones": "Prochains jalons",
        "milestone": "Jalon",
        "milestone_name": "Nom du jalon",
        "milestone_unit_count": "0 unités | 1 unité | {count} unités",
        "milestones": "Jalons",
        "new_milestone": "Nouveau jalon",
        "no_milestone": "Aucun jalon n'a encore été attribué",
        "no_results": "Aucun jalon trouvé",
        "past_milestones": "Jalons passés",
        "please_select": "Veuillez sélectionner un nouveau jalon",
        "position": "Position",
        "search_empty_state": "Aucun jalon n'a encore été créé. Cliquez ici pour commencer",
        "units": "Unités",
        "units_without_milestone": "1 unité sans jalon | {count} unités sans jalon",
        "warning_delete": "Si vous supprimez un jalon qui a été attribué à une unité, le client perdra de vue à quel jalon se trouve son unité. Assurez-vous d'attribuer un nouveau jalon à ces unités!"
      },
      "toasts": {
        "bulk_assigned": "Le jalon est attribué avec succès aux unités sélectionnées",
        "create_success": "Jalon créé avec succès",
        "deactivate_success": "Le jalon a été désactivé avec succès",
        "sup_assigned": "Le jalon est activé avec succès",
        "update_success": "Les jalons ont été mis à jour avec succès"
      },
      "validation": {
        "needName": "Nom requis",
        "needNamePrimary": "Le nom dans la langue principale ({language}) est requis"
      }
    }
  }
}
